import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";

/**
 * User context middleware will retrieve and set store references for branch info, services, orders, etc. to reduce the
 * need for individual pages to manage this context data.
 * Optionally, if a branch code and customer number are provided in the URL query, this middleware will overwrite
 * existing store values with the given parameters.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  // Only run on client
  if (import.meta.client) {
    const app = useNuxtApp();
    const store: Store<State> = useStore();
    const persistedState = store.state.persistedState;

    const queryBranchCode = to.query.franchise_id;
    const queryCustomerId = to.query.c;

    try {
      if (
        queryBranchCode &&
        queryCustomerId &&
        (persistedState.branchCode !== queryBranchCode ||
          persistedState.cust_No !== Number(queryCustomerId))
      ) {
        await app.$userContext.refresh({
          clearState: true,
          stateUpdate: {
            branchCode: queryBranchCode,
            custNo: Number(queryCustomerId)
          },
          refresh: new Set(['ALL'])
        });
      } else {
        // Merge all route.meta.userContext data
        const metaUserContext = {
          clearState: false,
          stateUpdate: {},
          refresh: new Set()
        };

        Array.isArray(to.meta) && to.meta.forEach((meta) => {
          if (meta.userContext) {
            metaUserContext.clearState =
              metaUserContext.clearState ||
              (meta.userContext.clearState ?? false);

            metaUserContext.stateUpdate = {
              ...metaUserContext.stateUpdate,
              ...meta.userContext.stateUpdate
            };

            if (meta.userContext.refresh && Array.isArray(meta.userContext.refresh)) {
              (meta.userContext.refresh as unknown[]).forEach((item) => {
                metaUserContext.refresh.add(item);
              });
            }
          }
        });

        await app.$userContext.refresh(metaUserContext);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      // Optionally, redirect to error page
      // return navigateTo('/error');
    } finally {
      // Optionally, strip query params from URL after processing
      // if (queryBranchCode && queryCustomerId) {
      //   const newQuery = { ...route.query };
      //   delete newQuery.franchise_id;
      //   delete newQuery.c;
      //   return navigateTo({ name: route.name, params: route.params, query: newQuery });
      // }
    }
  }
});
